import React from 'react'

const MainLayout = () => {
  return <div className="d-flex justify-content-center"/>
}

export default MainLayout
